// Copyright (c) 2016 Deere & Company

import SearchByDropDown from '../state/search-by-dropdown';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const findMatchingOption = (key, options) => options.find(option => option.key === key);

const updateSearchBy = (state, action) =>
    SearchByDropDown.update(state, {
        selectedOption: {
            $set: findMatchingOption(action.key, state.searchBy)
        }
    });

const actionTypes = {
    [actions.UPDATE_PART_REQUESTS_SEARCH_BY]: updateSearchBy
};

export default (state = getDefaultState().searchByDropdown, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/search-by-dropdown.js